import type { ReactElement, ReactNode } from 'react';
import { useState } from 'react';

import {
    createTooltipSettings, DEFAULT_TOOLTIP_DELAY_MS, DEFAULT_TOOLTIP_SKIP_MS,
    TooltipSettingsContext,
} from './tooltipContext';

// The settings keep one identity, and the tooltips write the skip window through its methods:
// a close must not render the other tooltips of the provider.
export const TooltipProvider = ({
    delayMs = DEFAULT_TOOLTIP_DELAY_MS,
    skipMs = DEFAULT_TOOLTIP_SKIP_MS,
    children,
}: {
    delayMs?: number;
    skipMs?: number;
    children: ReactNode;
}): ReactElement => {
    const [settings] = useState(() => createTooltipSettings(delayMs, skipMs));
    return (
        <TooltipSettingsContext.Provider value={settings}>
            {children}
        </TooltipSettingsContext.Provider>
    );
};
